import { render, staticRenderFns } from "./ClientOrdersPrint2PDF.vue?vue&type=template&id=0f968722&"
import script from "./ClientOrdersPrint2PDF.vue?vue&type=script&lang=js&"
export * from "./ClientOrdersPrint2PDF.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports